import { FC } from 'react';

import { BAR_CHART_HORIZONTAL_TEST_IDS } from '@/constants/data-testids';
import { cn } from '@/utils/tailwind.ts';

import { Card, CardContent } from '../../atoms/Card/Card';
import { Skeleton } from '../../atoms/Skeleton/Skeleton';

const CELL_SKELETON = [
  { id: 'cell-90', width: 90 },
  { id: 'cell-80', width: 80 },
  { id: 'cell-60', width: 60 },
  { id: 'cell-50', width: 50 },
  { id: 'cell-30', width: 30 },
];

type BarChartHorizontalSkeletonProps = {
  yAxisWidth: number;
};

export const BarChartHorizontalSkeleton: FC<BarChartHorizontalSkeletonProps> = ({ yAxisWidth }) => {
  return (
    <Card
      data-testid={BAR_CHART_HORIZONTAL_TEST_IDS.SKELETON}
      className="p-4 border-custom-warm-grey-150"
    >
      <CardContent>
        <div className="h-[18px] mb-6">
          <Skeleton className="w-[140px] h-[14px]" />
        </div>
        <div className="flex gap-[13px]">
          <div
            style={{
              width: yAxisWidth,
            }}
            className="flex flex-col gap-[21px]"
          >
            {' '}
            {Array.from({ length: 5 }, (_, index) => (
              <div key={index} className="h-[34px] flex items-center">
                <Skeleton className="w-full h-[14px]" />
              </div>
            ))}
          </div>
          <div className="w-full">
            <div className="relative flex flex-col gap-[20px] mb-3 border-l border-l-custom-warm-grey-400">
              {CELL_SKELETON.map(({ id, width }) => (
                <div key={id} className="flex items-center">
                  <Skeleton
                    style={{
                      width: `${width}%`,
                    }}
                    className="h-[35.6px] rounded-none rounded-tr-[6px] rounded-br-[6px]"
                  />
                </div>
              ))}
              <div className="absolute inset-0 flex justify-between">
                {Array.from({ length: 5 }, (_, index) => (
                  <div key={index} className="w-[40px] flex justify-center">
                    <span
                      className={cn('w-[1px] h-full animate-pulse', {
                        hidden: index === 0,
                      })}
                      style={{
                        backgroundImage:
                          'linear-gradient(to bottom, #F0EEED 33.33%, transparent 33.33%, transparent 66.66%, #F0EEED 66.66%)',
                        backgroundSize: '100% 24px',
                      }}
                    />
                  </div>
                ))}
              </div>
            </div>
            <div className="flex items-center justify-between">
              {Array.from({ length: 5 }, (_, index) => (
                <div key={index}>
                  <Skeleton className="w-[40px] h-[14px]" />
                </div>
              ))}
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};
